import { BaseResAPI } from "@/@core/entity/res-api.entity";
import { UserID } from "@/@core/entity/user.entity";
import api from "@/api/axios";

export interface EditUserDTO {
  pathParam: {
    userId: UserID;
  };
  body: {
    fullname: string;
    username: string;
    date_of_birth: string;
    gender: string;
    email: string;
    phone_number: string;
    bio: string;
    role: string;
    password: string;
    confirm_password: string;
    media_id?: number;
  };
}

export type EditUserResp = BaseResAPI<null>;

const editUserInteractor = (params: EditUserDTO): Promise<EditUserResp> => {
  const {
    pathParam: { userId },
    body,
  } = params;
  const path = `/admin/user/${userId}`;
  return api.put(path, body);
};

export default editUserInteractor;
